import React, {useState, useEffect } from "react";
import { UserProvider } from './Context/UserContext';
import {
  BrowserRouter as Router,
  Route,
  Routes,
} from "react-router-dom";

import { ThemeProvider, CssBaseline } from '@mui/material';
//import streetwearTheme from './Styles/streetwearTheme.js';
import darkModeTheme from './Styles/darkModeTheme.js';
//import lightModeTheme from './Styles/lightModeTheme.js';

import SkeletonPage from './Pages/SkeletonPage.js';
import SkeletonEvent from './Pages/SkeletonEvent.js';
import SkeletonWebPage from './Pages/SkeletonWebPage.js';
import CompanyPage from './Pages/CompanyPage.js';

import CompanyAnalyticsPage from './Pages/CompanyAnalyticsPage.js';

function App() {
  const getDimensions = () => {
    const { innerWidth: width, innerHeight: height } = window;
    return { width, height };
  };

  const [windowDimensions, setWindowDimensions] = useState(getDimensions());

  useEffect(() => {
    document.title = "Around Everything";
    const handleResize = () => {
      setWindowDimensions(getDimensions());
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <ThemeProvider theme={darkModeTheme}>
        <UserProvider>
          <CssBaseline />
          {windowDimensions.width <= 416 ? (
            <Router>
              <Routes>
                <Route
                  path="/"
                  element={<SkeletonPage />}
                />
                <Route
                    path="/company/analytics"
                    element={<CompanyAnalyticsPage />}
                />
                <Route
                  path="/SkeletonEvent/:id/:name/:description/:location/:address/:logo/:date/:time_string/:duration/:link"
                  element={<SkeletonEvent />}
                />
                {/* mobile company route now takes id param */}
                <Route
                  path="/company/:id"
                  element={<CompanyPage />}
                />
              </Routes>
            </Router>
          ) : (
            <SkeletonWebPage />
          )}
        </UserProvider>
    </ThemeProvider>
  );
}

export default App;